import { getDateWithoutTime } from '@crm-framework/utils';

import { IMessage } from './types';

/**
 * @param {Date} firstDate
 * @param {Date} secondDate
 */
export const isCompareDate = (firstDate: Date, secondDate: Date) =>
  getDateWithoutTime(firstDate).getTime() ===
  getDateWithoutTime(secondDate).getTime();

export const messageSorting = (a: IMessage, b: IMessage) =>
  new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
